<template>
  <div class="studentifno-editstudent">
    <!-- 编辑表单 -->
    <el-dialog
      :visible="dialogFormVisible"
      title="修改学生信息"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      center
      width="30%"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="姓名" label-width="100px" prop="studentName">
          <el-input
            v-model="formData.studentName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="性别" required>
          <el-radio-group v-model="formData.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学号" label-width="100px" prop="studentNumber">
          <el-input
            v-model="formData.studentNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级职务" label-width="100px" prop="duty">
          <el-input v-model="formData.duty" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="政治面貌"
          label-width="100px"
          prop="politicsStatus"
        >
          <el-input
            v-model="formData.politicsStatus"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="学生状态" label-width="100px" prop="status">
          <el-select v-model="formData.status" placeholder="请选择">
            <el-option
              v-for="item in studentTypeList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择班级" label-width="100px" prop="classNameVal">
          <el-cascader
            v-model="formData.classNameVal"
            :placeholder="classPlaceholder"
            :props="classProps"
            :options="classSelect"
            @change="changeHandle"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="家庭地址" label-width="100px" prop="address">
          <el-input v-model="formData.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // props: {
  //   dialogFormVisible: {
  //     type: Boolean,
  //     require: true,
  //   },
  //   studentInfo: {
  //     type: Object,
  //     default: () => {
  //       return {};
  //     },
  //   },
  // },
  props: [
    "dialogFormVisible",
    "studentInfo",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "classInfoArr",
    "studentTypeList",
  ],
  inject: ["refresh"],
  data() {
    return {
      formData: {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男"
      },
      rules: {
        studentName: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        // duty: [{ required: true, message: "请输入班级职务", trigger: "blur" }],
        // politicsStatus: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        studentNumber: [
          { required: true, message: "请输入学生学号", trigger: "blur" },
        ],
        classNameVal: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  mounted() {
    // this.classNameVal = this.classInfoArr;
  },
  methods: {
    // 选择班级
    changeHandle(e) {},
    dialogOpen() {
      console.log( this.studentInfo);
      
      Object.assign(this.formData, this.studentInfo);
      this.formData.sex = this.studentInfo.sex ? this.studentInfo.sex : "男";
      this.formData.classNameVal = this.classInfoArr;
    },
    dialogClose() {
      // let { studentName, studentNumber, address } = this.studentInfo;
      // this.formData.studentName = studentName;
      // this.formData.studentNumber = studentNumber;
      // this.formData.address = address;
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          // console.log("this.formData=> ", this.formData);
          let {
            studentName,
            studentNumber,
            address,
            duty,
            politicsStatus,
            status,
            sex
          } = this.formData;
          // 调用接口修改学生信息
          this.post(this.$url.updateStudentPC, {
            id: this.studentInfo.id,
            studentName,
            studentNumber,
            address,
            duty,
            sex,
            status,
            politicsStatus,
            gradeId: this.formData.classNameVal[0].gradeId,
            gradeName: this.formData.classNameVal[0].gradeName,
            classId: this.formData.classNameVal[1].classId,
            className: this.formData.classNameVal[1].className,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200 && res.data == 1) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
